import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { DollarSign } from 'lucide-react';
import './FormStyles.css';

const url = process.env.REACT_APP_BACKEND_URL;

const RegistrationFeeForm = ({ onSubmit, onBack, initialData }) => {
  const [banks, setBanks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    amount: '10', // Fixed default amount
    bank_id: initialData?.bank_id || '',
    bank_name: initialData?.bank_name || '',
    account_number: initialData?.account_number || '',
    reference_no: initialData?.reference_no || '',
    notes: initialData?.notes || ''
  });

  useEffect(() => {
    fetchBanks();
  }, []);

  const fetchBanks = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${url}/api/bank`);
      setBanks(response.data.data || []);
    } catch (error) {
      console.error('Failed to fetch banks:', error);
      toast.error('Failed to load bank list');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'bank_id') {
      const selectedBank = banks.find(bank => bank._id === value);
      setData(prev => ({
        ...prev,
        bank_id: value,
        bank_name: selectedBank?.bankname || '',
        account_number: selectedBank?.bankaccountno || ''
      }));
    } else {
      setData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate bank selection
    if (!data.bank_id) {
      toast.error('Please select a bank');
      return;
    }

    // Submit with fixed amount $10
    onSubmit({
      amount: '10',
      bank_id: data.bank_id,
      bank_name: data.bank_name,
      account_number: data.account_number,
      reference_no: data.reference_no,
      notes: data.notes
    });
  };

  if (loading) {
    return (
      <div className="form-card">
        <h2 className="form-title">
          <DollarSign size={24} /> Registration Fee
        </h2>
        <div className="loading-spinner">Loading bank details...</div>
      </div>
    );
  }

  return (
    <div className="form-card">
      <h2 className="form-title">
        <DollarSign size={24} /> Registration Fee
      </h2>

      <form className="dynamic-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Fee Amount *</label>
          <div className="amount-input-wrapper">
            <span className="currency-symbol">$</span>
            <input
              type="text"
              value="$10.00"
              disabled
              className="amount-disabled"
            />
          </div>
          <small className="field-hint">Registration fee is fixed at $10.00</small>
        </div>

        <div className="form-group">
          <label>Select Bank *</label>
          <select name="bank_id" value={data.bank_id} onChange={handleChange} required>
            <option value="">Select a bank</option>
            {banks.map(bank => (
              <option key={bank._id} value={bank._id}>
                {bank.bankname} - {bank.bankaccountno}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Bank Name</label>
          <input
            type="text"
            value={data.bank_name}
            disabled
            className="disabled-input"
            placeholder="Bank name will appear here"
          />
        </div>

        <div className="form-group">
          <label>Account Number</label>
          <input
            type="text"
            value={data.account_number}
            disabled
            className="disabled-input"
            placeholder="Account number will appear here"
          />
        </div>

        <div className="form-group">
          <label>Reference Number (Optional)</label>
          <input
            type="text"
            name="reference_no"
            value={data.reference_no}
            onChange={handleChange}
            placeholder="Enter reference number (e.g., transaction ID)"
          />
        </div>

        <div className="form-group">
          <label>Notes (Optional)</label>
          <textarea
            name="notes"
            value={data.notes}
            onChange={handleChange}
            placeholder="Enter any additional notes"
            rows="3"
          />
        </div>

        <div className="form-actions">
          <button type="button" onClick={onBack} className="back-btn">Back</button>
          <button type="submit" className="submit-btn">Complete →</button>
        </div>
      </form>
    </div>
  );
};

export default RegistrationFeeForm;